import PropTypes from "prop-types";

import { Chip, Grid, Paper, Typography } from "@mui/material";

import { chartOfAccountTypeLabels } from "@/features/chart-of-accounts";

export const GeneralInformationSection = ({ chartOfAccount }) => {
  const isActive = !chartOfAccount.deactivatedAt;
  const hasParent = Boolean(chartOfAccount.parent);

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Informasi Umum
      </Typography>
      <Grid container spacing={3}>
        {/* Kode */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="body2" gutterBottom sx={{
            color: "text.secondary"
          }}>
            Kode
          </Typography>
          <Typography variant="body1">{chartOfAccount.code}</Typography>
        </Grid>

        {/* Nama */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="body2" gutterBottom sx={{
            color: "text.secondary"
          }}>
            Nama
          </Typography>
          <Typography variant="body1">{chartOfAccount.name}</Typography>
        </Grid>

        {/* Status */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="body2" gutterBottom sx={{
            color: "text.secondary"
          }}>
            Status
          </Typography>
          <Chip
            label={isActive ? "Aktif" : "Nonaktif"}
            color={isActive ? "success" : "default"}
            size="small"
          />
        </Grid>

        {/* Tipe Akun */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="body2" gutterBottom sx={{
            color: "text.secondary"
          }}>
            Tipe Akun
          </Typography>
          <Typography variant="body1">
            {chartOfAccountTypeLabels[chartOfAccount.type]}
          </Typography>
        </Grid>

        {/* Merupakan Sub */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="body2" gutterBottom sx={{
            color: "text.secondary"
          }}>
            Merupakan Sub
          </Typography>
          <Typography variant="body1">{hasParent ? "Ya" : "Tidak"}</Typography>
        </Grid>

        {/* Turunan dari - only show when has parent */}
        {hasParent && (
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Typography variant="body2" gutterBottom sx={{
              color: "text.secondary"
            }}>
              Turunan dari
            </Typography>
            <Typography variant="body1">
              {chartOfAccount.parent?.name || "-"}
            </Typography>
          </Grid>
        )}

        {/* Khusus Outlet */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="body2" gutterBottom sx={{
            color: "text.secondary"
          }}>
            Khusus Outlet
          </Typography>
          <Typography variant="body1">
            {chartOfAccount.isOutletSpecific ? "Ya" : "Tidak"}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  chartOfAccount: PropTypes.object.isRequired,
};
